import React from 'react';
import {
  IconBan,
  IconLockOpen,
  IconTrash
} from '@tabler/icons-react';
import { GameIcon } from '../../constants/games';

const TunnelsTable = ({ tunnels, onBlock, onUnblock, onDelete }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-white dark:bg-dark-900 rounded-2xl border border-gray-200 dark:border-dark-800 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 dark:bg-dark-850">
            <tr>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-dark-500 uppercase">Туннель</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-dark-500 uppercase">Владелец</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-dark-500 uppercase">Адрес</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-dark-500 uppercase">Статус</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-dark-500 uppercase">Создан</th>
              <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 dark:text-dark-500 uppercase">Действия</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-dark-800">
            {tunnels.map(t => (
              <tr key={t.id} className="hover:bg-gray-50 dark:hover:bg-dark-850 transition-colors">
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-primary-500/20 to-primary-500/5 flex items-center justify-center">
                      <GameIcon gameId={t.game} name={t.name} className="w-8 h-8" />
                    </div>
                    <div>
                      <div className="font-medium text-gray-900 dark:text-white">{t.name}</div>
                      <div className="text-xs text-gray-500 dark:text-dark-600">
                        {t.game} • {t.protocol?.toUpperCase()}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className="text-gray-900 dark:text-white">{t.username}</span>
                </td>
                <td className="px-6 py-4">
                  <code className="px-2 py-1 bg-gray-100 dark:bg-dark-800 text-gray-700 dark:text-dark-300 text-sm rounded">
                    {t.public_host}:{t.public_port}
                  </code>
                </td>
                <td className="px-6 py-4">
                  {t.is_blocked ? (
                    <div>
                      <span className="inline-flex items-center gap-1 px-2 py-1 bg-red-500/20 text-red-500 text-xs rounded-full">
                        <IconBan className="w-3 h-3" />
                        Заблокирован
                      </span>
                      {t.blocked_until && (
                        <div className="text-xs text-gray-500 dark:text-dark-600 mt-1">
                          до {formatDate(t.blocked_until)}
                        </div>
                      )}
                      {t.block_reason && (
                        <div className="text-xs text-gray-500 dark:text-dark-600 mt-1">
                          {t.block_reason}
                        </div>
                      )}
                    </div>
                  ) : (
                    <span className={`inline-flex items-center gap-1 px-2 py-1 text-xs rounded-full ${
                      t.status === 'active' 
                        ? 'bg-green-500/20 text-green-500'
                        : 'bg-yellow-500/20 text-yellow-500'
                    }`}>
                      {t.status === 'active' ? 'Активен' : 'Ожидает'}
                    </span>
                  )}
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 dark:text-dark-400">
                  {formatDate(t.created_at)}
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center justify-end gap-2">
                    {t.is_blocked ? (
                      <button
                        onClick={() => onUnblock(t.id)}
                        className="p-2 text-green-500 hover:bg-green-500/20 rounded-lg transition-colors"
                        title="Разблокировать"
                      >
                        <IconLockOpen className="w-4 h-4" />
                      </button>
                    ) : (
                      <button
                        onClick={() => onBlock(t)}
                        className="p-2 text-yellow-500 hover:bg-yellow-500/20 rounded-lg transition-colors"
                        title="Заблокировать"
                      >
                        <IconBan className="w-4 h-4" />
                      </button>
                    )}
                    <button
                      onClick={() => onDelete(t.id)}
                      className="p-2 text-red-500 hover:bg-red-500/20 rounded-lg transition-colors"
                      title="Удалить"
                    >
                      <IconTrash className="w-4 h-4" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TunnelsTable;